export default __webpack_public_path__ + "static/media/dingdan.979bbebc.png";